"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isImageStencil = exports.imageStencilDefinition = void 0;
const properties_1 = require("../properties");
const speedweekContentAreas = [
    {
        name: 'main',
        items: [
            'title',
            'teaser',
            'image-essence',
        ],
    },
    {
        name: 'info',
        subAreas: [
            {
                name: 'General',
                items: [
                    'type-of-image',
                    'seo-filename',
                    'credits',
                    'geolocation',
                    'image-caption-flag',
                ],
            },
            {
                name: 'Settings',
                items: ['standalone'],
            },
            {
                name: 'Custom Properties',
                items: ['properties-container'],
            },
        ],
    },
    {
        name: 'tagging',
        items: [
            'disciplines',
            'content-categories',
            'related-content',
        ],
    },
];
const wrcErcContentAreas = [
    {
        name: 'main',
        items: [
            'title',
            'teaser',
            'image-essence',
        ],
    },
    {
        name: 'info',
        subAreas: [
            {
                name: 'General',
                items: [
                    'type-of-image',
                    'seo-filename',
                    'credits',
                    'geolocation',
                    'image-caption-flag',
                ],
            },
            {
                name: 'Settings',
                items: ['standalone'],
            },
            {
                name: 'Custom Properties',
                items: ['properties-container'],
            },
        ],
    },
    {
        name: 'tagging',
        items: [
            'disciplines',
            'content-categories',
            'tag-events',
            'tag-event-series',
            'tag-rally-drivers',
            'tag-rally-teams',
            'related-content',
        ],
    },
];
exports.imageStencilDefinition = {
    view: {
        label: 'Image',
        category: 'image',
        group: 'Images',
        titleItems: ['title'],
        imageItems: ['image-essence'],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'title',
                    'teaser',
                    'image-essence',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'type-of-image',
                            'seo-filename',
                            'credits',
                            'geolocation',
                            'image-caption-flag',
                        ],
                    },
                    {
                        name: 'Settings',
                        items: ['standalone'],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: [
                    'disciplines',
                    'content-categories',
                    'tag-events',
                    'tag-event-series',
                    'tag-persons',
                    'tag-photographers',
                    'tag-judges',
                    'tag-teams',
                    'related-content',
                ],
            },
        ],
    },
    content: {
        'content-categories': properties_1.contentCategoriesPropertyDefinition,
        'image-caption-flag': properties_1.imageCaptionFlagPropertyDefinition,
        'image-essence': properties_1.imageEssencePropertyDefinition,
        'properties-container': properties_1.propertiesContainerPropertyDefinition,
        'related-content': properties_1.relatedContentPropertyDefinition,
        'seo-filename': properties_1.seoFilenamePropertyDefinition,
        'tag-event-series': properties_1.tagEventSeriesPropertyDefinition,
        'tag-events': properties_1.tagEventsPropertyDefinition,
        'tag-judges': properties_1.tagJudgesPropertyDefinition,
        'tag-persons': properties_1.tagPersonsPropertyDefinition,
        'tag-photographers': properties_1.tagPhotographersPropertyDefinition,
        'tag-rally-drivers': properties_1.tagRallyDriversPropertyDefinition,
        'tag-rally-teams': properties_1.tagRallyTeamsPropertyDefinition,
        'tag-teams': properties_1.tagTeamsPropertyDefinition,
        'type-of-image': properties_1.typeOfImagePropertyDefinition,
        credits: properties_1.creditsPropertyDefinition,
        disciplines: properties_1.disciplinesPropertyDefinition,
        geolocation: properties_1.geolocationPropertyDefinition,
        standalone: properties_1.standalonePropertyDefinition,
        teaser: properties_1.teaserPropertyDefinition,
        title: {
            ...properties_1.titlePropertyDefinition,
            constraints: [
                properties_1.titlePropertyDefinition.constraints[0],
                {
                    name: 'maxLength',
                    argument: 75,
                },
            ],
        },
    },
    localizations: [],
    roles: [],
    spaces: [
        'alinghi',
        'batalla',
        'brand-building-events',
        'cartoons',
        'erc',
        'global',
        'illume',
        'media-partnerships',
        'organics',
        'organics-mixed-consumption',
        'pro-cycling',
        'racing-bulls',
        'rb-juniorteam',
        'rb-rookies',
        'rbtv',
        'rbtv_temporary',
        'redbull_com',
        'redbull-advancedtechnologies',
        'redbull-f1academy',
        'redbull-powertrains',
        'redbull-racing',
        'redbull-simracing',
        'redbulletin',
        'redbullmusic',
        'speedweek',
        'wingfinder',
        'wrc',
        'xalps',
    ],
    overwrites: [
        {
            condition: 'space',
            argument: 'speedweek',
            contentAreas: speedweekContentAreas,
        },
        {
            condition: 'space',
            argument: 'erc',
            contentAreas: wrcErcContentAreas,
        },
        {
            condition: 'space',
            argument: 'wrc',
            contentAreas: wrcErcContentAreas,
        },
    ],
    name: 'image',
};
const isImageStencil = (stencil) => {
    return stencil.name === exports.imageStencilDefinition.name;
};
exports.isImageStencil = isImageStencil;
//# sourceMappingURL=data:application/json;base64,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